import React from "react";

const BusinessLoadingState = () => {
  return (
    <div className="flex min-h-[400px] items-center justify-center">
      <div className="mx-auto max-w-md p-6 text-center">
        <div className="bg-muted mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
          <div className="border-primary h-8 w-8 animate-spin rounded-full border-b-2"></div>
        </div>

        <h3 className="text-foreground mb-2 text-lg font-semibold">
          Loading Businesses
        </h3>

        <p className="text-muted-foreground">
          Please wait while we load your business information...
        </p>
      </div>
    </div>
  );
};

export default BusinessLoadingState;
